import React, { useContext, useEffect } from 'react';
import { Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import AdminNavbar from 'components/Navbars/AdminNavbar';
import SuperAdminPage from 'views/SuperAdmin/SuperAdminPage';
import SuperAdminLeadsPage from 'views/SuperAdmin/SuperAdminLeadsPage';
import SuperAdminMirandaPage from 'views/SuperAdmin/SuperAdminMirandaPage';
import SuperAdminPlansPage from 'views/SuperAdmin/SuperAdminPlansPage';
import { ApiContext } from '../../contexts/ApiContext';
import { accountPath } from '../../utils/accountPath';

function SuperAdminLayout() {
  const navigate = useNavigate();
  const { token, isSuperAdmin, homeAccountId } = useContext(ApiContext);

  useEffect(() => {
    if (!token) {
      navigate('/login');
      return;
    }
    if (token && !isSuperAdmin && homeAccountId) {
      navigate(accountPath(homeAccountId, '/dashboard'), { replace: true });
    }
  }, [token, isSuperAdmin, homeAccountId, navigate]);

  if (!token || !isSuperAdmin) {
    return null;
  }

  return (
    <div className="wrapper">
      <div className="main-panel" style={{ width: '100%' }}>
        <AdminNavbar brandText="Super Admin" toggleSidebar={() => {}} sidebarOpened={false} />
        <Routes>
          <Route path="/" element={<SuperAdminPage />} />
          <Route path="/leads" element={<SuperAdminLeadsPage />} />
          <Route path="/miranda" element={<SuperAdminMirandaPage />} />
          <Route path="/planos" element={<SuperAdminPlansPage />} />
          <Route path="*" element={<Navigate to="/superadmin" replace />} />
        </Routes>
      </div>
    </div>
  );
}

export default SuperAdminLayout;
